<template>
    <div v-if="is_logged_in && !is_widget_user">
        <div v-if="is_mobile" class="mobile-nav-activator">
            <v-btn icon="mdi-menu" variant="text" rounded="0" @click="drawer = true"></v-btn>
        </div>

        <v-navigation-drawer
            v-model="drawer"
            app
            floating
            location="left"
            elevation="0"
            width="230"
            :permanent="!is_mobile"
            class="nav_drawer_container"
        >
            <div class="d-flex flex-column justify-space-between h-100">
                <div>
                    <v-list nav density="compact" class="pb-1">
                        <WorkspaceSelector />
                        <WorkspaceOptions />
                    </v-list>
                </div>
                <div
                    class="d-flex flex-shrink-1 flex-grow-1 overflow-y-auto"
                    style="scrollbar-gutter: stable"
                >
                    <ExpertSelection />
                </div>

                <div class="d-flex flex-column ga-3 mt-3">
                    <v-list nav density="compact" class="pb-1">
                        <ProcessesButton />
                    </v-list>
                    <UserIdentifier
                        v-if="current_user"
                        id="user-menu-activator"
                        :user="current_user"
                        class="ml-2 mb-2 menu-activator"
                        :activator-id="'#user-menu-activator'"
                        :show-admin-mode="should_show_admin"
                        @logout="logout"
                    />
                </div>
            </div>
        </v-navigation-drawer>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useDisplay } from 'vuetify';

import { useUserStore } from '@/stores/user';
import { storeToRefs } from 'pinia';

import UserIdentifier from '@/components/utils/bits/UserIdentifier.vue';
import ExpertSelection from './ExpertSelection.vue';
import WorkspaceSelector from './WorkspaceSelector.vue';
import WorkspaceOptions from './WorkspaceOptions.vue';
import ProcessesButton from './ProcessesButton.vue';
// Store initialization
const userStore = useUserStore();
const display = useDisplay();

// Extract reactive refs from stores using storeToRefs
const {
    is_logged_in,
    is_widget_user,
    get_user: current_user,
    should_show_admin,
} = storeToRefs(userStore);

// Reactive state
const drawer = ref(true);

// Computed properties
const is_mobile = computed(() => display.smAndDown.value);

const logout = () => {
    userStore.logout('You were logged out. See you soon!');
};
</script>

<style lang="scss" scoped>
.nav_drawer_container {
    transition-property:
        box-shadow, transform, visibility, width, height, left, right, top, bottom, filter;
    background-color: var(--color-background);
}

.mobile-nav-activator {
    position: absolute;
    top: 0;
    left: 5px;
    z-index: 49;
}

.menu-activator {
    cursor: pointer;
    background: none;
    border-radius: 4px;
    padding: 0 8px 0 8px;
    margin-right: 8px;
    transition: all 0.2s ease-in-out;

    &:hover,
    &.menu-open {
        background: #e0e0e0 !important;
    }
}
</style>
